import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { InfractionCategory } from '../fine-admin/models/infraction-category.model';

@Injectable({
  providedIn: 'root'
})
export class FineService extends BaseProvider {
  private finesSubject: BehaviorSubject<any> = new BehaviorSubject([]);
  public readonly currentFines: Observable<any> = this.finesSubject.asObservable();

  private fineSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public readonly currentFine: Observable<any> = this.finesSubject.asObservable();

  itemToEdit: any = { Id: '' };
  infractionCategory: InfractionCategory[] = [];
  infractionParentCategory: any[] = [];
  fineIsLoading = false;
  constructor(public globals: GlobalsService, public http: HttpClient) {
    super();

    this.baseUrl = 'fine';
  }

  searchFines(params) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl +
        '/term/' + params.term +
        '/page/' + params.pageNumber +
        '/size/' + params.pageSize +
        '/inspection/' + params.inspectionId +
        '/active/' + params.active +
        '/direction/' + params.direction;

      this.http
        .get(this.url)
        .subscribe(
          (data: any) => {
            console.log('searchFines', data.Data);

            data.Data.forEach(item => {
              if (item.ExternalInfractionIds) {
                item.ExternalInfractionIdsArray = item.ExternalInfractionIds.split(',').map(id => id.trim());
              }
            });

            this.finesSubject.next(data.Data);
            resolve(data.Data);
          },
          err => { reject(err); }
        );
    });
  }

  searchPofileFines(params) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl +
        '/term/' + params.term +
        '/page/' + params.pageNumber +
        '/size/' + params.pageSize +
        '/active/' + params.active +
        '/direction/' + params.direction;

      this.http
        .get(this.url)
        .subscribe(
          (data: any) => {
            console.log('searchFines', data.Data);

            data.Data.forEach(item => {
              if (item.ExternalInfractionIds) {
                item.ExternalInfractionIdsArray = item.ExternalInfractionIds.split(',').map(id => id.trim());
              }
            });

            this.finesSubject.next(data.Data);
            resolve(data.Data);
          },
          err => { reject(err); }
        );
    });
  }

  searchFinesByProfile(params) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl +
        '/term/null' +
        '/page/' + params.pageNumber +
        '/size/' + params.pageSize +
        '/profile/' + params.profileId +
        '/active/' + params.active +
        '/direction/' + params.direction;

      this.http
        .get(this.url)
        .subscribe(
          (data: any) => {
            console.log('searchFines', data.Data);
            data.Data.forEach(item => {
              if (item.ExternalInfractionIds) {
                item.ExternalInfractionIdsArray = item.ExternalInfractionIds.split(',').map(id => id.trim());
              }
            });
            this.finesSubject.next(data.Data);
            resolve(data.Data);
          },
          err => { reject(err); }
        );
    });
  }

  getById(id) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/' + id;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.setFineDetail(data.Data.fine);
          resolve(data.Data.infractions);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  setFineDetail(fine: any) {
    this.itemToEdit = fine;
    this.fineSubject.next(fine);
  }

  getInfractionCategory(term: string) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl +
        '/infractionCategory/term/' + term;

      this.http
        .get(this.url)
        .subscribe(
          (data: any) => {
            this.infractionCategory = data.Data;
            console.log('this.infractionCategory', this.infractionCategory);
            resolve(data.Data);
          },
          err => { reject(err); }
        );
    });
  }

  getInfractionParentCategory() {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl +
        '/infractionParentCategory/';

      this.http
        .get(this.url)
        .subscribe(
          (data: any) => {
            this.infractionParentCategory = data.Data;
            resolve(data.Data);
          },
          err => { reject(err); }
        );
    });
  }

  create(params) {
    console.log('params', params);
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl;

      this.http
        .post(
          this.url,
          params
        )
        .subscribe(
          (data: any) => {
            resolve(data);
          },
          err => { reject(err); }
        );
    });
  }

  update(id: string, params: any) {
    return new Promise((resolve, reject) => {
      this.url = `${this.globals.dataUrl}${this.baseUrl}/${id}`;

      this.http
        .put(
          this.url,
          params
        )
        .subscribe(
          (data: any) => {
            resolve(data);
          },
          err => { reject(err); }
        );
    });
  }
}
